import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function rejectionNoteValidatorFactory(
  firstName?: string,
  isActive?: () => boolean,
  minAfterTemplate = 1
): ValidatorFn {
  const template = firstName ? `Hello ${firstName},` : '';

  return (control: AbstractControl): ValidationErrors | null => {
    if (isActive && !isActive()) return null;
    const raw = (control.value ?? '') as string;
    const value = raw.replace(/\u200B/g, '').trim();
    if (!value) return { required: true };
    if (template) {
      const startsWithTemplate = value.startsWith(template);
      if (startsWithTemplate) {
        const after = value.slice(template.length).trim();
        if (after.length === 0) return { unchangedTemplate: true };
        if (after.length < minAfterTemplate) return { tooShortAfterTemplate: { required: minAfterTemplate } };
      }
    }
    return null;
  };
}
